import Vue from 'vue'

const STORAGE_KEY = 'app-theme'
const DARK_CLASS = 'theme-dark'

/**
 * Menedzer motywu aplikacji (jasny / ciemny).
 *
 * Klasa motywu (`theme-dark`) jest nakladana na <html> (document.documentElement).
 * <html> jest przodkiem zarowno #app, jak i nakladek montowanych na <body>
 * (vuejs-dialog z $h.confirm, v-tooltip, powiadomienia), wiec selektory `.theme-dark X`
 * dzialaja w calej aplikacji.
 *
 * Wybor uzytkownika jest zapisywany w localStorage pod kluczem `app-theme`.
 */
const ThemeManager = {
    /** Reaktywny stan motywu wspoldzielony z komponentami Vue. */
    state: Vue.observable({
        theme: 'light'
    }),

    /**
     * Zwraca zapisany motyw z localStorage lub domyslnie 'light'.
     * @returns {'light'|'dark'}
     */
    getStoredTheme() {
        try {
            const stored = localStorage.getItem(STORAGE_KEY)
            return stored === 'dark' ? 'dark' : 'light'
        } catch (e) {
            return 'light'
        }
    },

    /**
     * Czy aktualnie aktywny jest tryb ciemny.
     * @returns {boolean}
     */
    isDark() {
        return this.state.theme === 'dark'
    },

    /**
     * Naklada klase motywu na <html> zgodnie z aktualnym stanem.
     */
    _applyClasses() {
        const root = document.documentElement
        if (root) root.classList.toggle(DARK_CLASS, this.state.theme === 'dark')
    },

    /**
     * Inicjalizuje motyw na podstawie zapisanej preferencji.
     * Wywolac mozliwie wczesnie (w main.js przed montowaniem), by uniknac migotania.
     */
    init() {
        this.state.theme = this.getStoredTheme()
        this._applyClasses()
    },

    /**
     * Ustawia konkretny motyw i zapisuje go w localStorage.
     * @param {'light'|'dark'} theme
     */
    setTheme(theme) {
        this.state.theme = theme === 'dark' ? 'dark' : 'light'
        try {
            localStorage.setItem(STORAGE_KEY, this.state.theme)
        } catch (e) {
            // brak dostepu do localStorage - dzialamy tylko w pamieci
        }
        this._applyClasses()
    },

    /**
     * Przelacza miedzy trybem jasnym a ciemnym.
     */
    toggle() {
        this.setTheme(this.isDark() ? 'light' : 'dark')
    }
}

export default ThemeManager
